import { getZoneFromSite, getSiteNameFromHostname } from '@seek/melways-sites';

const getZone = (clientDomain: string) => {
  try {
    const siteName = getSiteNameFromHostname(clientDomain);
    // @ts-ignore
    return getZoneFromSite(siteName);
  } catch (e) {
    return '';
  }
};

export default getZone;
